/**
 * Returns lock state for a price based on purchase history.
 * Only billingType is locked when a price has been purchased.
 * Amount / currency / interval / intervalCount remain editable.
 */
export function usePriceLockState(price) {
  return {
    billingTypeLocked: !!(price && price.hasBeenPurchased),
  };
}
